/* Live countdown veilingwerken (TD, 22-7-2026).
   Zoekt [data-td-countdown]-elementen; alle teksten/labels komen als
   data-attributen mee uit Liquid (td-t), het script zelf is taalvrij.
   Wordt per snippet-render ingevoegd; de guard hieronder zorgt dat er
   maar één klok loopt. */
(function () {
  'use strict';
  if (window.__tdCountdown) return;
  window.__tdCountdown = true;

  function pad(n) {
    return n < 10 ? '0' + n : '' + n;
  }

  function render(el, now) {
    var end = parseInt(el.getAttribute('data-end'), 10);
    if (!end) return;
    var left = end - now;
    var mode = el.getAttribute('data-mode');

    if (left <= 0) {
      var endedText = el.getAttribute('data-ended') || '';
      if (mode === 'compact') {
        var v = el.querySelector('[data-td-value]');
        if (v) v.textContent = endedText;
      } else {
        el.classList.add('td-countdown--ended');
        el.innerHTML = '<span class="td-countdown__endedtext">' + endedText + '</span>';
      }
      el.setAttribute('data-done', '1');
      return;
    }

    var d = Math.floor(left / 86400);
    var h = Math.floor((left % 86400) / 3600);
    var m = Math.floor((left % 3600) / 60);
    var s = left % 60;

    if (mode === 'compact') {
      var u = (el.getAttribute('data-units') || 'd|h|m|s').split('|');
      var txt;
      if (left < 3600) {
        txt = m + u[2] + ' ' + pad(s) + u[3];
      } else if (d === 0) {
        txt = h + u[1] + ' ' + pad(m) + u[2];
      } else {
        txt = d + u[0] + ' ' + pad(h) + u[1] + ' ' + pad(m) + u[2];
      }
      var val = el.querySelector('[data-td-value]');
      if (val) val.textContent = (el.getAttribute('data-prefix') || '') + ' ' + txt;
    } else {
      var dEl = el.querySelector('[data-td-d]');
      var hEl = el.querySelector('[data-td-h]');
      var mEl = el.querySelector('[data-td-m]');
      var sEl = el.querySelector('[data-td-s]');
      var dSeg = el.querySelector('[data-td-seg="d"]');
      if (dSeg) dSeg.style.display = d === 0 ? 'none' : '';
      if (dEl) dEl.textContent = d;
      if (hEl) hEl.textContent = pad(h);
      if (mEl) mEl.textContent = pad(m);
      if (sEl) sEl.textContent = pad(s);
    }
    el.classList.add('td-countdown--ready');
  }

  function tick() {
    var els = document.querySelectorAll('[data-td-countdown]:not([data-done])');
    if (!els.length) return;
    var now = Math.floor(Date.now() / 1000);
    for (var i = 0; i < els.length; i++) render(els[i], now);
  }

  tick();
  setInterval(tick, 1000);
  document.addEventListener('shopify:section:load', tick);
})();
